import React, { useContext, useEffect, useState } from "react";
import "./AddStudentForm.css";
import TextFieldInput from "../../../Atoms/Inputs/TextField/TextFieldInput";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Typography } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import useSave from "../../../../Hooks/useSave";
import useEdit from "../../../../Hooks/useEdit";
import { BaseURL, schoolListURL, studentURL } from "../../../../Hooks/URL";
import { Formik } from "formik";
import * as Yup from "yup";
import useFetch from "../../../../Hooks/useFetch";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import phone from "phone";
import { PhoneInput } from "react-international-phone";
import { userContext } from "../../../../Contexts/userContext";
import useFetchWhen from "../../../../Hooks/useFetchWhen";
import { images } from "../../../../Assets/assetsHelper";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { grades } from "../../../../Assets/grades";

const AdminStudentSchema = Yup.object().shape({
  name: Yup.string().required("Name required !!"),
  gender: Yup.string().required("Gender required !!"),
  nationalId: Yup.string().required("National ID required !!"),
  schoolId: Yup.string().required("School required !!"),
  grade: Yup.string().required("Grade required !!"),
});

const StudentSchema = Yup.object().shape({
  name: Yup.string().required("Name required !!"),
  gender: Yup.string().required("Gender required !!"),
  nationalId: Yup.string().required("National ID required !!"),
  grade: Yup.string().required("Grade required !!"),
});

function AddStudentForm({
  Edit = false,
  student,
  url,
  setStudent,
  setOpen,
  Open,
  setStudents,
  page,
  search,
}) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  const [file, setFile] = useState("");
  const [date, setDate] = useState(dayjs(student?.birthDay) ?? "");
  const [newObject, setNewObject] = useState({});
  const [Phone, setPhone] = useState("");
  const [PhoneError, setPhoneError] = useState(null);
  const [PhoneTouched, setPhoneTouched] = useState(false);
  const [goEdit, setGoEdit] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const {
    state,
    fetchNewData,
    loading: editLoading,
  } = useEdit(url, goEdit, setGoEdit, newObject, false, true);
  const { saveState, loading: addLoading } = useSave({
    url: studentURL,
    goSave,
    setGoSave,
    newObject,
    isImage: true,
  });
  const { data: schoolsList } = useFetchWhen(
    schoolListURL,
    contextData?.role == "admin"
  );

  const handleUploadClick = (e) => {
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!phone(Phone)?.isValid) setPhoneError("Valid Phone Number Required!!");
    else setPhoneError("");
  }, [Phone]);

  useEffect(() => {
    if (student) {
      setPhone(student?.parentPhone ?? "");
    }
  }, [student]);

  useEffect(() => {
    if (state.dataRes.status == "success") {
      navigate("/students");
    }
  }, [state, navigate, setOpen]);

  useEffect(() => {
    if (saveState.dataRes.status == "success") {
      navigate("/students");
    }
  }, [saveState, navigate, setOpen]);

  return (
    <div className="SmallFormWrapper">
      <Formik
        initialValues={
          contextData?.role == "admin"
            ? {
                name: Edit ? student?.name ?? "" : "",
                gender: Edit ? student?.gender ?? "" : "",
                nationalId: Edit ? student?.nationalId ?? "" : "",
                schoolId: Edit ? student?.school?.id ?? "" : "",
                grade: Edit ? student?.grade ?? "" : "",
              }
            : {
                name: Edit ? student?.name ?? "" : "",
                gender: Edit ? student?.gender ?? "" : "",
                nationalId: Edit ? student?.nationalId ?? "" : "",
                grade: Edit ? student?.grade ?? "" : "",
              }
        }
        validationSchema={
          contextData?.role == "admin" ? AdminStudentSchema : StudentSchema
        }
        onSubmit={(values) => {
          if (!PhoneError)
            if (student) {
              const prev =
                contextData?.role == "admin"
                  ? {
                      name: student?.name ?? "",
                      birthDay: student?.birthDay ?? "",
                      gender: student?.gender ?? "",
                      nationalId: student?.nationalId ?? "",
                      schoolId: student?.school?.id ?? "",
                      grade: student?.grade ?? "",
                    }
                  : {
                      name: student?.name ?? "",
                      birthDay: student?.birthDay ?? "",
                      gender: student?.gender ?? "",
                      nationalId: student?.nationalId ?? "",
                      grade: student?.grade ?? "",
                    };
              const newObj = { ...values, birthDay: date };
              if (file)
                setNewObject({
                  ...Object.fromEntries(
                    Object.entries({
                      ...prev,
                      ...values,
                      parentPhone: Phone,
                    }).filter(([key]) => prev[key] != values[key])
                  ),
                  photo: file,
                });
              else
                setNewObject(
                  Object.fromEntries(
                    Object.entries({
                      ...prev,
                      ...values,
                      parentPhone: Phone,
                    }).filter(([key]) => prev[key] != values[key])
                  )
                );
              setGoEdit(true);
            } else {
              setNewObject({
                ...values,
                birthDay: date,
                photo: file,
                parentPhone: Phone,
              });
              setGoSave(true);
            }
          else {
            setPhoneTouched(true);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="FormContainer">
              <div className="LeftForm">
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "space-between",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <label
                      className="aboutLabel"
                      style={{ marginBottom: "20px" }}
                    >
                      Student Photo:
                    </label>
                    {(file && file !== "null") ||
                    (student?.photoFilePath && file !== "null") ? (
                      <Button
                        component="label"
                        variant="contained"
                        color="secondary"
                        startIcon={<CloseIcon style={{ fontSize: "20" }} />}
                        className="ImageInputButton RemovePhoto"
                        onClick={() => {
                          setFile("null");
                        }}
                      />
                    ) : (
                      ""
                    )}
                    <img
                      src={
                        file && file !== "null"
                          ? URL.createObjectURL(file)
                          : student?.photoFilePath && file !== "null"
                          ? `${BaseURL}/${student?.photoFilePath}`
                          : images.upload
                      }
                      style={{
                        width: "120px",
                        height: "120px",
                        cursor: "pointer",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                      onClick={() => {
                        setFile("null");
                      }}
                    />
                    <Button
                      component="label"
                      variant="contained"
                      startIcon={<CloudUploadIcon style={{ fontSize: "25" }} />}
                      className="ImageInputButton uploadButton"
                    >
                      <input
                        accept="image/*"
                        className={"ImageInput"}
                        id="contained-button-file"
                        type="file"
                        onChange={handleUploadClick}
                      />
                    </Button>
                  </div>
                </div>
                <TextFieldInput
                  fullWidth
                  type="text"
                  placeholder={"Enter Student Name"}
                  className="Input"
                  label={"Student Name"}
                  name={"name"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.name}
                />
                {errors.name && touched.name && errors.name && (
                  <p className="error">
                    {errors.name && touched.name && errors.name}
                  </p>
                )}

                <TextFieldInput
                  select
                  label="Gender"
                  newValue={values.gender}
                  name={"gender"}
                  change={handleChange}
                  blur={handleBlur}
                  style={{ margin: "10px 0" }}
                  fullWidth
                  className={`StudentSelect ${
                    values.gender == "" ? "StudentSelect-placeholder" : ""
                  }`}
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="StudentSelect" disabled>
                    Choose Student Gender
                  </MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </TextFieldInput>
                {errors.gender && touched.gender && errors.gender && (
                  <p className="error">
                    {errors.gender && touched.gender && errors.gender}
                  </p>
                )}
              </div>
              <div className="RightForm">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      className="Input full DataInput"
                      name={"birthDay"}
                      label="Birth Date"
                      value={date}
                      onChange={(newValue) => setDate(newValue)}
                      fullWidth
                    />
                  </DemoContainer>
                </LocalizationProvider>
                {errors.birthDay && touched.birthDay && errors.birthDay && (
                  <p className="error">
                    {errors.birthDay && touched.birthDay && errors.birthDay}
                  </p>
                )}

                <TextFieldInput
                  select
                  label="Grade"
                  newValue={values.grade}
                  name={"grade"}
                  change={handleChange}
                  blur={handleBlur}
                  style={{ margin: "10px 0" }}
                  fullWidth
                  className={`StudentSelect ${
                    values.grade == "" ? "StudentSelect-placeholder" : ""
                  }`}
                  variant="outlined"
                  SelectProps={{
                    displayEmpty: true,
                  }}
                >
                  <MenuItem value="" className="StudentSelect" disabled>
                    Choose Student Grade
                  </MenuItem>
                  {grades?.map((gradeItem) => (
                    <MenuItem value={gradeItem?.id}>{gradeItem?.name}</MenuItem>
                  ))}
                </TextFieldInput>
                {errors.grade && touched.grade && errors.grade && (
                  <p className="error">
                    {errors.grade && touched.grade && errors.grade}
                  </p>
                )}

                <div style={{ position: "relative", marginBottom: "0px" }}>
                  <label className="labelPhone">Parent Phone Number</label>
                  <PhoneInput
                    label={"Enter Parent Phone Number"}
                    className="textfield Input phoneInput"
                    value={Phone}
                    defaultCountry="eg"
                    onChange={(e) => {
                      setPhone(e);
                    }}
                  />
                  {PhoneError && PhoneTouched ? (
                    <p className="error">{PhoneError}</p>
                  ) : (
                    ""
                  )}
                </div>

                <TextFieldInput
                  fullWidth
                  type="text"
                  label={"Student National ID"}
                  placeholder={"Enter Student National ID"}
                  className="Input"
                  name={"nationalId"}
                  change={handleChange}
                  blur={handleBlur}
                  newValue={values.nationalId}
                />
                {errors.nationalId &&
                  touched.nationalId &&
                  errors.nationalId && (
                    <p className="error">
                      {errors.nationalId &&
                        touched.nationalId &&
                        errors.nationalId}
                    </p>
                  )}

                {contextData?.role == "admin" ? (
                  <>
                    <TextFieldInput
                      select
                      label="School"
                      newValue={values.schoolId}
                      name={"schoolId"}
                      change={handleChange}
                      blur={handleBlur}
                      fullWidth
                      className={`CourseSelect Input`}
                      variant="outlined"
                      SelectProps={{
                        displayEmpty: true,
                      }}
                    >
                      <MenuItem value="" className="teacherSelect" disabled>
                        Choose School
                      </MenuItem>
                      {schoolsList?.data?.map((schoolItem) => (
                        <MenuItem value={schoolItem?.id}>
                          {schoolItem?.name}
                        </MenuItem>
                      ))}
                    </TextFieldInput>
                    {errors.schoolId && touched.schoolId && errors.schoolId && (
                      <p className="error">
                        {errors.schoolId && touched.schoolId && errors.schoolId}
                      </p>
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                className="actionButton primary addButton"
                onClick={handleSubmit}
                disabled={Edit ? editLoading : addLoading}
              >
                {Edit ? (
                  editLoading ? (
                    <PulseLoader color="white" size={8} />
                  ) : (
                    "Edit"
                  )
                ) : addLoading ? (
                  <PulseLoader color="white" size={8} />
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export default AddStudentForm;
